import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';
import { v } from '@/theme/tokens';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: IconName;
  action?: ReactNode;
}

export function EmptyState({ title, description, icon = 'inbox', action }: EmptyStateProps) {
  return (
    <div className="rt-empty" style={{ padding: '48px 24px', textAlign: 'center' }}>
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: v('panel'),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
          color: v('ink-muted'),
        }}
      >
        <Icon name={icon} size={24} />
      </div>
      <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{title}</div>
      {description && (
        <div style={{ fontSize: 13.5, color: v('ink-muted'), maxWidth: 460, margin: '0 auto 18px' }}>
          {description}
        </div>
      )}
      {action}
    </div>
  );
}
